/* eslint camelcase: ["error", {properties: "never"}] */

import * as THREE from "three";
import { PersonPoint } from "./PersonPoint";
import { db, ensureFirebaseAuth } from "../../../../db";

const maxHeight = 5000 * 0.8;
const maxRadius = 1000 * 0.8;
const zero = new THREE.Vector3(0, 0, 0);
const defaultConfig = {
  max_particles: 300,
  min_particles: 1,
  max_dist: 200,
  min_dist: 40,
};

class QingMing {
  constructor() {
    this.playerDist = Infinity;
    this.model = new THREE.Group();
    this.personPoints = [];
    this.visibleParticles = 0;
    this.config = defaultConfig;
    this._init();
  }

  async _init() {
    ensureFirebaseAuth();
    db.collection("project_configs")
      .doc("huiyi-qingming")
      .onSnapshot((doc) => {
        this.config = doc.data();
        // console.log(this.config);
        const { scale, position } = this.config;
        this.model.scale.set(scale * 0.001, scale * 0.001, scale * 0.001);
        this.model.position.set(position.x, position.y, position.z);
      });
  }

  _calcPlayerDist(playerPosition) {
    return playerPosition.distanceToSquared(this.model.position);
  }

  update(playerPosition) {
    const prev = this.visibleParticles;
    this.playerDist = this._calcPlayerDist(playerPosition);

    // if it's over the far end, display min particle
    // if it's inside the near end, display max particle
    const curr = Math.floor(
      (this.config.max_particles - this.config.min_particles) *
        Math.min(
          Math.max(
            (this.config.max_dist - this.playerDist) /
              (this.config.max_dist - this.config.min_dist),
            0.01
          ),
          1
        )
    );

    if (curr === prev) return;

    // turn on/off particles until
    const visible = curr > prev;
    const [start, end] = [curr, prev].sort((a, b) => a - b);

    // lazy creating particles
    if (this.personPoints.length < end) {
      this.addPoints(zero, end - this.personPoints.length);
    }

    for (let i = start; i < end; i++)
      this.personPoints[i].model.visible = visible;

    this.visibleParticles = curr;
    // console.log("curr: ", curr);
    // console.log("dist: ", this.playerDist);
  }

  // please call animate on everyframe.
  // if the player is too far away, it won't do anything.
  animate() {
    if (this.playerDist > this.config.max_dist) return;
    for (
      let i = 0;
      i < Math.min(this.visibleParticles, this.personPoints.length);
      i++
    ) {
      this.personPoints[i].update();
    }
  }

  addPoints(initPosition, pointsNumber) {
    const heightNumber = 3;
    let currentSinRange =
      Math.floor(Math.random() * 100) + Math.floor(pointsNumber / heightNumber);
    let sinCounter = 0;
    for (let i = 0; i < pointsNumber; i++) {
      if (sinCounter > currentSinRange) {
        sinCounter = 0;
        currentSinRange =
          Math.floor(Math.random() * 100) +
          Math.floor(pointsNumber / heightNumber);
      }
      const sinIndex = Math.PI * (sinCounter / currentSinRange);
      let randomRadius = 0;
      randomRadius =
        (Math.abs(Math.sin(sinIndex)) * maxRadius + 500) * Math.random() + 50;
      const personPoint = new PersonPoint(
        randomRadius,
        Math.random() * maxHeight,
        initPosition
      );
      personPoint.model.name = this.personPoints.length - 1;
      this.personPoints.push(personPoint);
      this.model.add(personPoint.model);
      sinCounter += 1;
    }
  }
}

const qingming = new QingMing();

export default qingming;
